// extracted by mini-css-extract-plugin
export default {"heading":"Ky-z","corrected":"Ly-z","redirectVerbiageContainer":"My-z","redirectVerbiageText":"Ny-z"};